<div class="header-container">
  @if (config.EnableSelectAll) {
  <button matTooltipShowDelay="500" [ngClass]="{ unselected: !selectAll }" mat-mini-fab class="mini-buttons"
    (click)="selectAllPress()" [matTooltip]="!selectAll ? 'Select All' : 'Unselect All'">
    <mat-icon> check_box </mat-icon>
  </button>
  } @if (config.DateItem && !config.DateRequired) {
  <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" (click)="toggleDateSearch()"
    matTooltip="Toggle Date Picker">
    <mat-icon>
      {{ enableDateSearch ? 'event_busy' : 'event_available' }}
    </mat-icon>
  </button>
  } @if (enableDateSearch) {
  <div class="input-wrapper mat-no-underline mat-no-bottom-padding pointer">
    @if (!config.DateItem?.Singular && config.DateItem?.Type != 'time') {
    <div>
      <mat-form-field>
        <mat-label>{{ config.DateItem?.Title ? config.DateItem?.Title : 'Choose Range' }}</mat-label>
        <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
          <input matStartDate placeholder="Start date" [formControl]="startDateForm" readonly />
          <input matEndDate (dateChange)="dateChangeOccurred($event)" placeholder="End date" [formControl]="endDateForm"
            readonly />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    } @if (config.DateItem?.Type == 'day' && config.DateItem?.Singular) {
    <mat-form-field>
      <mat-label>{{ config.DateItem?.Title ? config.DateItem?.Title : 'Choose Day' }}</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="startDateForm" readonly="true" (click)="picker.open()" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    } @if (config.DateItem?.Type == 'month' && config.DateItem?.Singular) {
    <app-month-picker [title]="config.DateItem?.Title" [defaultValue]="config.DateItem?.StartDate"
      (valueChangeEvent)="datePickerChanged($event)"> </app-month-picker>
    } @if (config.DateItem?.Type == 'year' && config.DateItem?.Singular) {
    <app-year-picker [title]="config.DateItem?.Title" [defaultValue]="config.DateItem?.StartDate"
      (valueChangeEvent)="datePickerChanged($event)"> </app-year-picker>
    } @if (config.DateItem?.Type == 'time' && !config.DateItem?.Singular) {
    <div>
      <app-date-time-picker [compact]="true" [providedDate]="config.DateItem?.StartDate"
        [label]="config.DateItem?.Title" (notify)="startDateTimeChange.emit($event)">
      </app-date-time-picker>
      to
      <app-date-time-picker [compact]="true" [providedDate]="config.DateItem?.EndDate" [label]="config.DateItem?.Title"
        (notify)="endDateTimeChange.emit($event)">
      </app-date-time-picker>
    </div>
    }
  </div>
  }
  <div class="drop-downs">
    @for (item of config.DropDownOptions; track item) {
    <div class="input-wrapper">
      @if (item.MultipleDropdowns) {
      <mat-form-field class="group-select-dropdown">
        <mat-label>{{ item.Label }}</mat-label>
        <mat-select (selectionChange)="dropdownEmit($event, item)" multiple>
          @for (option of item.options; track option) {
          <mat-option [value]="option">{{ item.attribute == '' ? option : option[item.attribute] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      } @if (!item.MultipleDropdowns) {
      <mat-form-field class="group-select-dropdown">
        <mat-label>{{ item.Label }}</mat-label>
        <mat-select (selectionChange)="dropdownEmit($event, item)">
          @for (option of item.options; track option) {
          <mat-option [value]="option">{{ item.attribute == '' ? option : option[item.attribute] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </div>
    } @if (config.ShowSearch) {
    <div class="input-wrapper searchbar">
      @if (this.searchQuery.value != null && this.searchQuery.value != '') {
      <mat-icon class="search-icons red" (click)="clearSearch()" matTooltip="Clear"
        matTooltipShowDelay="500">clear</mat-icon>
      }
      <input class="searchbar" matInput [placeholder]="config.SearchPlaceholder" [formControl]="searchQuery"
        (keyup.enter)="submitRefresh()" />
      <mat-icon class="search-icons" (click)="submitRefresh()" matTooltip="Search"
        matTooltipShowDelay="500">search</mat-icon>
    </div>
    } @if (config.SortItems && config.SortItems.length != 0) {
    <div class="input-wrapper">
      <mat-form-field class="mat-no-underline mat-no-bottom-padding">
        <mat-label>Sort By</mat-label>
        <mat-select (selectionChange)="sortChanged()" [(value)]="sortValue">
          @for (value of config.SortItems; track value) {
          <mat-option [value]="value.Name">
            {{ value.Display }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (sortValue) {
      <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" (click)="sortDirectionChanged()"
        [matTooltip]="this.sortOrderIsDesc ? 'Desc' : 'Asc'">
        <mat-icon>{{ this.sortOrderIsDesc ? 'arrow_downwards' : 'arrow_upwards' }}</mat-icon>
      </button>
      } @if (sortValue) {
      <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" (click)="sortApplied()"
        [matTooltip]="this.sortChange ? 'Apply Sort' : 'Clear Sort'">
        <mat-icon>{{ this.sortChange ? 'done' : 'clear' }}</mat-icon>
      </button>
      }
    </div>
    }
    <div class="filter-div">
      @if (config.FilterItems) {
      <button matTooltipShowDelay="500" matTooltip="Filter" mat-mini-fab class="mini-buttons" (click)="toggleFilters()">
        <mat-icon> filter_alt </mat-icon>
      </button>
      } @if (this.showFilters) {
      <div class="filter">
        @if (searchFiltersLength > 0) {
        <div class="title-wrapper"> Search Filters </div>
        } @if (searchFiltersLength > 0) {
        <div class="filter-container">
          @for (filter of getSearchFilters(); track filter) {
          <mat-form-field appearance="outline" class="mat-no-bottom-padding-all">
            <mat-label>{{ filter.Name }}</mat-label>
            <input matInput [formControl]="this.filterForms[filter.Name]" (keydown.enter)="applyFilters()" />
          </mat-form-field>
          }
        </div>
        } @if (selectionFiltersLength > 0) {
        <div class="title-wrapper"> Selection Filters </div>
        } @if (selectionFiltersLength > 0) {
        <div class="filter-container">
          @if(selectionFilterLoading){
            <div class="spinner-container">
              <mat-spinner></mat-spinner>
            </div>
          }@else{
            @if (config.SearchFilters){
              @for (filter of getSelectionFilters(); track filter) {
                @if(filter.compareFn!=null){
                <tools-searchable-combobox
                  [comboboxHeading]="filter.Name"
                  [comboboxPlaceholderName]="'Search ' + filter.Name"
                  [column]="'Name'"
                  [unFilteredOptions]="filter.Values"
                  [preSelected]="[filterForms[filter.Name].value]"
                  [multipleAllowed]="false"
                  [allAllowed]="false"
                  [isRequired]="false"
                  (notify)="filterForms[filter.Name].setValue($event); config.DynamicFilterUpdateFn ? dynamicallyUpdateFilters() : null">
                </tools-searchable-combobox>
                } @else{
                  <tools-searchable-combobox
                    [comboboxHeading]="filter.Name"
                    [comboboxPlaceholderName]="'Search ' + filter.Name"
                    [column]="'Name'"
                    [unFilteredOptions]="transformToObjectArray(filter.Values)"
                    [preSelected]="[{ Name: filterForms[filter.Name].value }]"
                    [multipleAllowed]="false"
                    [allAllowed]="false"
                    [isRequired]="false"
                    (notify)="filterForms[filter.Name].setValue($event?.Name); config.DynamicFilterUpdateFn ? dynamicallyUpdateFilters() : null">
                  </tools-searchable-combobox>
                }
              }
            }@else {
              @for (filter of getSelectionFilters(); track filter) {
                <mat-form-field class="mat-no-bottom-padding-all" appearance="outline">
                  <mat-label>{{ filter.Name }}</mat-label>
                    @if(filter.compareFn!=null){
                      <mat-select [formControl]="this.filterForms[filter.Name]"
                                  (selectionChange)="config.DynamicFilterUpdateFn!=null ? dynamicallyUpdateFilters() : null"
                                  [compareWith]="filter.compareFn??null">
                        @for (value of filter.Values; track value) {
                          <mat-option [value]="value">
                            @if(filter.Wrapper!=null){
                              {{filter.Wrapper(value)}}
                            }@else{
                              {{ value }}
                            }
                          </mat-option>
                        }
                      </mat-select>
                    }@else{
                      <mat-select [formControl]="this.filterForms[filter.Name]"
                                  (selectionChange)="config.DynamicFilterUpdateFn!=null ? dynamicallyUpdateFilters() : null">
                        @for (value of filter.Values; track value) {
                          <mat-option [value]="value">
                            @if(filter.Wrapper!=null){
                              {{filter.Wrapper(value)}}
                            }@else{
                              {{ value }}
                            }
                          </mat-option>
                        }
                      </mat-select>
                    }
                </mat-form-field>
              }
            }

          }
        </div>
        } @if (config && config.ToggleFilters && config.ToggleFilters.length > 0) {

        <div class="title-wrapper">Toggle Filters</div>
        <div class="filter-container">
          @for (filter of config.ToggleFilters; track filter) {
          <div class="slide-wrapper">
            <mat-slide-toggle [formControl]="filterForms[filter.Name]">{{ filter.Name }}</mat-slide-toggle>
          </div>
          }
        </div>

        }
        <div class="filter-actions">
          <button matTooltipShowDelay="500" mat-raised-button class="word-buttons" (click)="clearFilters()"
            matTooltip="Clear Filters"> Clear Filters </button>
          <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" matTooltip="Apply Filters"
            (click)="applyFilters()">
            <mat-icon> done </mat-icon>
          </button>
        </div>
      </div>
      }
    </div>
    @if (config.EnableAddButton) {
    <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" matTooltip="Add Item"
      (click)="this.newItemAdded.emit()">
      <mat-icon> add </mat-icon>
    </button>
    } @if (config.EnableImport) {
    <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" (click)="this.importPressed()"
      matTooltip="Import">
      <mat-icon> upload </mat-icon>
    </button>
    } @if (config.EnableExport) {
    <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" matTooltip="Export"
      (click)="this.exportPress()">
      <mat-icon> download </mat-icon>
    </button>
    } @if (config.EnableView) {
    <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" matTooltip="View"
      (click)="this.viewPressed.emit()">
      <mat-icon> monitor </mat-icon>
    </button>
    } @if (config.EnableClear) {
    <button matTooltipShowDelay="500" mat-mini-fab class="mini-buttons" matTooltip="Clear"
      (click)="this.clearPressed.emit()">
      <mat-icon> clear </mat-icon>
    </button>
    }
  </div>
</div>
